import * as React from 'react';
import { History } from 'history';
import '../styles.css';

interface IProps {
    history: History;
}

export default (props: IProps) => {
  return (
    <section className="legalContent">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <p style={{ textAlign: "center", fontSize: "1.25em" }}>
              <b>Privacy Policy</b>
            </p>
            <p>
              Protecting your private information is our priority. This Privacy
              Policy applies to Harmonize<sup>&reg;</sup>, a web-based
              application that helps educational institutions and other
              organizations manage resources and partnerships. Harmonize
              <sup>&reg;</sup> is accessible through the website and is
              comprised of various web pages and all related products, software,
              and services (referred to collectively as the &#8220;Product&#8221; in this
              document). Harmonize<sup>&reg;</sup> was created and is operated
              by Digital Congruence Corporation d/b/a Harmonize
              <sup>&reg;</sup> (collectively referred to as
              &#8220;Harmonize&#8221;). This Privacy Policy governs data collection
              and usage and describes the types of personal information we
              collect about our customers, how we use the information, with whom
              we share it, and various other information. By using the Harmonize
              Product, you consent to the policy described below.
            </p>

            <p>
              <b>Collection of Your Personal Information</b>
            </p>
            <p>
              Harmonize may collect the following information from organizations
              and/or individual users:
            </p>
            
            

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>
                      <b>Category</b>
                    </p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>
                      <b>Examples</b>
                    </p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>
                      <b>Source</b>
                    </p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>
                      <b>Purpose</b>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Identifiers</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Name, email, IP address, device ID</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Directly from user</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Account creation, communication</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Customer Records</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Billing address, phone number, account credentials</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Directly from user</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Fulfillment of services</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Internet Activity</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Browsing history, clicks, search terms, cookies, device data</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>User interactions on platform</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Platform analytics and improvement</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Geolocation Data</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Approximate IP-based location</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Automatically collected</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Security, content customization</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Employment Information</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Job title, employer name (if provided)</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Directly from user</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Platform customization</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Inferences</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>User preferences or interests based on usage patterns</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Derived from use</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Product development and personalization</p>
                  </td>
                </tr>
              </tbody>
            </table>

            <br />
            <p>
              We may also receive personal data from third-party vendors, such
              as analytics or hosting services.
            </p>
            
            <p>
              Harmonize encourages you to review this Privacy Policy frequently
              along with the privacy statements of websites you choose to link
              to from Harmonize so that you can understand how those websites
              collect, use, and share your information. Harmonize is not
              responsible for the privacy statements or other content on
              websites outside of the Harmonize website.
            </p>

            <p>
              <b>Share of Your Personal Information</b>
            </p>
            <p>Harmonize may share your personal information as follows:</p>
            <ul>
              <li>
                Harmonize may share end user data, in aggregate, with clients.
              </li>
              <li>
                Harmonize may share data with trusted third-party vendors who
                perform services on Harmonize&#8217;s behalf. Third-party vendors may help
                perform statistical analysis, send you email or postal mail, provide customer
                support, and provide a host of other services for Harmonize and its customers.
              </li>
              <li>
                Harmonize may also disclose your personal information, without
                notice, if required to do so by law or in the good faith belief
                that such action is necessary to: (a) conform to the
                requirements of the law or comply with legal process served on
                Harmonize; (b) law enforcement authorities or other government
                officials; (c) protect and defend the rights or property of
                Harmonize; and (d) act under exigent circumstances to protect
                the personal safety of users of Harmonize, or the public.
              </li>
              <li>
                Harmonize also reserves the right to transfer personal
                information it has about you in the event Harmonize sells or
                transfers all or a portion of its business or assets (including
                in the event of reorganization, dissolution, or liquidation).
              </li>
            </ul>

            <p>
              You have the ability to accept or decline cookies. Most web
              browsers automatically accept cookies, but you can usually modify
              your browser setting to decline cookies if you prefer. If you
              choose to decline cookies, you may not be able to fully experience
              the interactive features of the Harmonize services or websites you
              visit.
            </p>
            

            <p>
              <b>Security of Your Personal Information</b>
            </p>
            <p>
              Harmonize will take reasonable technical and organizational
              precautions to prevent the loss, misuse, or alteration of your
              personal information. Information relating to electronic
              transactions entered into the Harmonize Product via this website
              will be protected by encryption technology. However, no data
              transmission over the Internet or data storage system can be
              guaranteed to be 100% secure. Please do not send us credit card
              information and/or other sensitive information through email. If
              you have reason to believe that your interaction with us is not
              secure, you must immediately notify us of the problem by
              contacting us in accordance with the &quot;Contact Information&quot; section
              below.
            </p>
            

            <p>
              <b>Cross-Border Data Transfers</b>
            </p>
            <p>
              Information that Harmonize collects may be stored and processed in
              and transferred between any of the countries in which Harmonize
              operates to enable the use of the information in accordance with
              this Privacy Policy. By using the Harmonize website and submitting
              any personal information, you consent to the transfer of personal
              information to other countries, which may provide a different
              level of data security than your country of residence provides.
              You agree to such cross-border transfers of personal information.
            </p>

            <p>
              <b>Children Under Thirteen</b>
            </p>
            <p>
              Harmonize does not knowingly collect personally identifiable
              information from children under the age of thirteen.
            </p>
            

            <p>
              <b>Use of Cookies</b>
            </p>
            <p>
              We use cookies and similar technologies (e.g., web beacons, server
              logs) to enhance your experience with the Harmonize Product.
              Cookies help remember your preferences, improve site performance,
              and enable analytics through services like Google Analytics. You
              can manage or disable cookies through your browser settings.
              Please note that disabling cookies may limit certain features or
              functionality of the Harmonize Product.
            </p>

            <p>
              <b>Online Tracking and How We Respond to Do Not Track Signals</b>
            </p>
            <p>
              We use tracking tools, such as cookies, web beacons, and Google
              Analytics, to understand how users interact with the Harmonize
              Product. This helps us analyze usage trends, improve our services,
              and enhance user experience. We may collect information such as
              the website you visited before arriving at Harmonize, the pages
              you visit while using our Product, and the website you navigate to
              after leaving. We also automatically collect certain device and
              browser information, including your IP address, browser type,
              domain name, access times, and referring URLs. We do not allow
              third-party advertising partners to collect your personal
              information for targeted advertising across other websites. Some
              browsers offer a &#8220;Do Not Track&#8221; (DNT) signal to indicate that you do
              not want your online activities tracked. At this time, the Harmonize
              Product does not respond to DNT signals, and your activity on our
              site may still be collected for internal analytics and
              functionality purposes as described in this Privacy Policy. For
              more information on how to manage your preferences, including how
              to opt out of certain tracking tools or communications, please see
              the &#8220;Opt-Out &amp; Unsubscribe&#8221; section below.
            </p>
            

            <p>
              <b>Data Retention Policy</b>
            </p>
            <p>
              We retain personal information only for as long as necessary to
              fulfill the purposes outlined in this Privacy Policy, unless a
              longer retention period is required or permitted by law. When we
              no longer need to use your personal information, we will delete or
              anonymize it.
            </p>
            

            <p>
              <b>Notice to California Residents:</b>
            </p>
            <p>
              <b>
                California Consumer Privacy Act (CCPA) and California Privacy
                Rights Act (CPRA) Disclosures
              </b>
            </p>
            <p>
              If you are a California resident, you have certain rights under
              the California Consumer Privacy Act (&#8220;CCPA&#8221;) as amended by the
              California Privacy Rights Act (&#8220;CPRA&#8221;). These rights apply to the
              personal information that Harmonize collects, uses, and discloses.
              This section supplements our general Privacy Policy.
            </p>
            

           <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>
                      <b>Right</b>
                    </p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>
                      <b>What It Means</b>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Right to Know</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>See what personal information we have collected, used, or shared.</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Right to Delete</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Ask us to delete personal information, with some exceptions.</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Right to Correct</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Ask us to fix inaccurate information we have about you.</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Right to Opt-Out of Sharing</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>Stop us from sharing your data for targeted advertising.</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Right to Limit Use (Sensitive PI)</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>We do not collect sensitive personal information in a way that requires limitation.</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "1px solid black" }}>
                    <p>Right to Non-Discrimination</p>
                  </td>
                  <td style={{ border: "1px solid black" }}>
                    <p>You will not be penalized for exercising your privacy rights.</p>
                  </td>
                </tr>
              </tbody>
            </table>

            <br />
            <p>
              <b>1. Right to Know About Personal Information Collected,
              Disclosed, or Sold</b>
            </p>
            <p>
              You have the right to request the following information about our
              data practices in the past 12 months:
            </p>
            <ul>
              <li>The categories of personal information we collected about you.</li>
              <li>The categories of sources from which we collected the personal information.</li>
              <li>The business or commercial purpose for collecting or selling personal information.</li>
              <li>The categories of third parties with whom we shared personal information.</li>
              <li>The specific pieces of personal information we collected about you.</li>
            </ul>
            
            <p>
              To exercise this right, please contact us using the methods
              described below in the &#8220;How to Submit a Request&#8221; section.
            </p>
            

            <p>
              <b>2. Right to Delete Personal Information</b>
            </p>
            <p>
              You may request that we delete personal information we have
              collected from you, subject to certain exceptions (such as
              compliance with legal obligations, fraud prevention, and service
              provision).
            </p>
            

            <p>
              <b>3. Right to Correct Inaccurate Personal Information</b>
            </p>
            <p>
              You may request that we correct inaccurate personal information
              that we maintain about you.
            </p>
            

            <p>
              <b>4. Right to Opt-Out of Sale or Sharing of Personal Information</b>
            </p>
            <p>
              We do not sell personal information for monetary consideration. We
              do not share your personal information with third parties for
              cross-context behavioral advertising, which may be considered a
              &#8220;sale&#8221; or &#8220;sharing&#8221; under California law.
            </p>
            <p>
              Global Privacy Control (GPC): We recognize and honor browser-based
              opt-out signals such as the Global Privacy Control (GPC). When we
              receive a valid GPC signal, we treat it as a request to opt out of
              the sale or sharing of your personal information for that browser
              or device.
            </p>
            

            <p>
              <b>5. Right to Limit Use of Sensitive Personal Information</b>
            </p>
            <p>
              We do not collect or process &#8220;sensitive personal
              information&#8221; as defined by the CPRA in a manner that requires a
              &#8220;Limit Use&#8221; option. If this changes, we will update our policy
              accordingly.
            </p>
            

            <p>
              <b>6. Right to Non-Discrimination</b>
            </p>
            <p>
              We will not discriminate against you for exercising your CCPA
              rights. This includes not denying you goods or services, not
              charging you different prices or rates, and not providing a
              different level or quality of services.
            </p>
            

            <p>
              <b>How to Submit a Request</b>
            </p>
            <p>
              To exercise any of the rights described above, you may submit a
              verifiable request to us by:
            </p>
            <ul>
              <li>Email: info@myharmonize.com</li>
              <li>
                Mailing address: Digital Congruence Corporation d/b/a Harmonize,
                1313 Ponce de Leon Blvd., Suite 301, Coral Gables, FL 33134
              </li>
            </ul>
            
            <p>
              To protect your privacy, we will verify your identity before
              fulfilling your request. This may involve confirming details
              you&#8217;ve previously provided to us or requesting additional
              documentation.
            </p>
            
            <p>
              You may also designate an authorized agent to make a request on
              your behalf.
            </p>
            
            <p>
              We may update this section of the Privacy Policy to reflect
              changes in our data practices or legal requirements. We will
              notify you of material changes via email or by posting a notice on
              our website.
            </p>
            

            <p>
              <b>Opt-Out &amp; Unsubscribe</b>
            </p>
            <p>
              We respect your privacy and give you an opportunity to opt out of
              receiving announcements of certain information. Users may opt out
              of receiving any or all communications from Harmonize by clicking
              the &#8220;unsubscribe&#8221; link at the bottom of any communication or by
              contacting us here:
            </p>
            <ul>
              <li>Email: info@myharmonize.com</li>
              <li>
                Mailing address: Digital Congruence Corporation d/b/a Harmonize,
                1313 Ponce de Leon Blvd., Suite 301, Coral Gables, FL 33134
              </li>
            </ul>
            
            <p>
              To learn more about how to opt out of ad network interest-based
              advertising, please visit the consumer opt-out website at{" "}
              <a href="http://www.aboutads.info/choices/">
                http://www.aboutads.info/choices/
              </a>
            </p>

            <p>
              <b>Changes to This Policy</b>
            </p>
            <p>
              Harmonize reserves the right, in its sole discretion, to change
              this Policy. Harmonize encourages you to periodically review the
              Policy to stay informed of our updates. Your continued use of the
              site following posting of changes to these terms will mean you
              accept these changes. If we change the Policy in any material way,
              we will provide appropriate notice to you via email.
            </p>
            

            <p>
              <b>Contact Information</b>
            </p>
            <p>
              Harmonize welcomes your questions or comments regarding this
              Privacy Policy. If you have any questions regarding this Policy,
              please contact Harmonize at:
            </p>
            <p>
              Digital Congruence Corporation d/b/a Harmonize
              <br />
              1313 Ponce de Leon Blvd., Suite 301
              <br />
              Coral Gables, FL 33134
              <br />
              <br />
              Email address: info@myharmonize.com
              <br />
              Telephone number: 305-535-0914
              <br />
              Effective as of August 11, 2025
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/public/privacy/index.tsx